
/**
 * @imports
 */
import * as main from './main.js';
import * as actors from './actors.js';

const Observer = { ...main, ...actors };

export default Observer;